import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { LoginDevicesCollection } from './login-devices.types';

export function loginDevicesBackend(): Backend<LoginDevicesCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'users/0.1/self/devices',
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: (authUid, id, loginDevice) => ({
      endpoint: 'users/0.1/self/devices',
      method: 'POST',
      payload: {
        login_device_tokens: [loginDevice.token ?? ''],
      },
    }),
  };
}
